export default "__VITE_ASSET__BTKADecG__"